import ModelIndexDirectus from './ModelIndexDirectus.vue'
import ModelIndexPage from './ModelIndexPage.vue'

export const registerModelIndexComponents = (Vue) => {
  Vue.component('ModelIndexDirectus', ModelIndexDirectus)
  Vue.component('ModelIndexPage', ModelIndexPage)
  Vue.component(
    'IconSelectInput',
    $frameworkUtils.defineAsyncComponent(() => import('../../front/Icons/IconSelectInput.vue')),
  )
}
